import { CATEGORY_IDS } from 'ContentUtils/constants/Categories';
export const ContentTypes = {
  LANDING_PAGE: 'landingPage',
  SITE_PAGE: 'sitePage',
  BLOG: 'blog',
  BLOG_POST: 'blogPost',
  KNOWLEDGE_BASE: 'knowledgeBase',
  KNOWLEDGE_ARTICLE: 'knowledgeArticle',
  CUSTOMER_PORTAL: 'customerPortal',
  PORTAL_INSTANCE: 'portalInstance',
  // Can be used a fallback type for testing content that doesn't have a specific type defined here yet
  CONTENT: 'content'
};
export const ContentGroupTypes = [ContentTypes.BLOG, ContentTypes.KNOWLEDGE_BASE, ContentTypes.CUSTOMER_PORTAL, ContentTypes.PORTAL_INSTANCE, ContentTypes.CONTENT];
export const DataWallContentGroupTypes = [ContentTypes.BLOG];
export const DataWallContentTypes = [ContentTypes.BLOG_POST];
export const CategoryIdToAccessControlContentType = {
  [CATEGORY_IDS.LANDING_PAGE]: ContentTypes.LANDING_PAGE,
  [CATEGORY_IDS.SITE_PAGE]: ContentTypes.SITE_PAGE,
  [CATEGORY_IDS.BLOG_LISTING_PAGE]: ContentTypes.BLOG,
  [CATEGORY_IDS.BLOG_POST]: ContentTypes.BLOG_POST,
  [CATEGORY_IDS.KNOWLEDGE_BASE_ILP]: ContentTypes.KNOWLEDGE_ARTICLE
};